import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { useAuthStore } from "@/stores/auth";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "start",
      component: HomeView,
      meta: {
        title: "murnau.rocks",
        icon: "home",
        fullScreen: false,
        hidden: true,
        bare: true,
      },
    },
    {
      path: "/steam",
      name: "Steam",
      component: () => import("../components/apps/steam/Steam.vue"),
      meta: {
        title: "Steam",
        kicker: "Spiele",
        subtitle: "Profile nachschlagen und Bibliotheken vergleichen.",
        navTitle: "Steam",
        icon: "play",
        perm: "steam",
      },
    },
    {
      path: "/syncwatch",
      name: "SyncWatch",
      component: () => import("../components/apps/syncwatch/SyncWatch.vue"),
      meta: {
        title: "SyncWatch",
        kicker: "SinusBot",
        subtitle: "Wiedergabe synchron zum Bot.",
        navTitle: "SyncWatch",
        icon: "watch",
        perm: "syncwatch",
        bare: true,
        fill: true,
      },
    },
    {
      path: "/humble",
      name: "Humble",
      component: () => import("../components/apps/humble/Humble.vue"),
      meta: {
        title: "HumbleZone",
        kicker: "Keys",
        navTitle: "Humble",
        icon: "gift",
        perm: "humble",
      },
    },
    {
      path: "/cook",
      name: "Kochbuch",
      component: () => import("../views/CookView.vue"),
      meta: {
        title: "KitchenMate",
        kicker: "Rezepte",
        navTitle: "Kochbuch",
        icon: "coffee",
        perm: "cook",
      },
    },
    {
      path: "/chat",
      name: "chat",
      component: () => import("../components/apps/Chat.vue"),
      meta: {
        title: "MessageHole",
        kicker: "Chat",
        subtitle: "Persistenter Raum — Log in Mongo, Replay per Offset.",
        navTitle: "Chat",
        icon: "message-square",
        perm: "chat",
      },
    },
    {
      path: "/ai",
      name: "AI",
      component: () => import("../components/apps/ai/AI.vue"),
      meta: {
        title: "Studio",
        kicker: "Ollama",
        subtitle: "Chat gegen lokale Modelle über FastAPI.",
        navTitle: "AI",
        icon: "aperture",
        requiresAuth: true,
        perm: "ai",
      },
    },
    {
      path: "/ytdl",
      name: "yt-dl",
      component: () => import("../components/apps/ytdl/Ytdl.vue"),
      meta: {
        title: "yt-dl",
        kicker: "Audio",
        subtitle: "YouTube nach MP3, Archiv auf dem Server.",
        navTitle: "yt-dl",
        icon: "download",
        requiresAuth: true,
        perm: "ytdl",
      },
    },
    {
      path: "/admin",
      name: "Admin",
      component: () => import("../views/UsersAdmin.vue"),
      meta: {
        title: "Administration",
        kicker: "System",
        subtitle: "Benutzer, Rollen und Daten-Tools.",
        navTitle: "Admin",
        icon: "shield",
        requiresAuth: true,
        perm: "users",
      },
    },
    {
      path: "/users",
      redirect: "/admin",
      meta: { hidden: true },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/LoginView.vue"),
      meta: {
        title: "Anmelden",
        kicker: "Konto",
        subtitle: "Chat für alle Accounts. AI und Benutzerverwaltung nur Admin.",
        icon: "log-in",
        hidden: true,
      },
    },
    {
      path: "/settings",
      redirect: "/",
      meta: { hidden: true },
    },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  try {
    if (!auth.guestLoaded) await auth.fetchGuest();
    if (!auth.user && auth.token) await auth.fetchMe();
  } catch {
    /* API down — keep going with fallback guest perms */
  }
  const perm = to.meta.perm as string | undefined;
  if (perm && !auth.can(perm)) {
    if (!auth.isLoggedIn) {
      return { path: "/login", query: { next: to.fullPath } };
    }
    return { path: "/" };
  }
  if ((to.meta.requiresAuth || to.meta.adminOnly) && !auth.isLoggedIn) {
    return { path: "/login", query: { next: to.fullPath } };
  }
  return true;
});

export default router;
